import detailsSagas from './details/containers/details-sagas';
import createSagas from './create/containers/create-order-saga';
import changePartnerSagas from './change-partner/containers/change-partner-sagas';
import partsSagas from './parts/containers/parts-sagas';
import taskListsSagas from './task-list/containers/task-list-sagas';

export default [
  ...detailsSagas,
  ...createSagas,
  ...changePartnerSagas,
  ...partsSagas,
  ...taskListsSagas,
];
